import gsap from "gsap";
import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";
import { _splitText } from "../utils/_splitText";

class AnimateHeading extends MainClass {
    el: {
        header: NodeListOf<HTMLElement>;
    };

    constructor(props: MAIN_CLASS_PARAMS) {
        super(props);

        this.el = {
            header: this.selector.querySelectorAll(".animate-heading"),
        };

        this.init();
    }
    init() {
        this.el.header.forEach((el) => {
            new _splitText({ target: el });
        });

        const checkHeadingVisibility = () => {
            const targets = this.el.header;
            const windowHeight = window.innerHeight;
            const triggerPoint = windowHeight / 1.3;

            targets.forEach((target) => {
                const rect = target.getBoundingClientRect();
                const elementTop = rect.top;
                const wordElements = target.querySelectorAll(".word");

                if (elementTop < triggerPoint) {
                    if (!target.classList.contains("animated-in")) {
                        // Animate in only if not already animated in
                        gsap.fromTo(
                            wordElements,
                            { y: 65 },
                            {
                                y: 0,
                                duration: 0.5,
                                stagger: 0.05,
                                delay: 0.5,
                            },
                        );
                        target.classList.add("animated-in");
                        target.classList.remove("animated-out");
                    }
                } else {
                    if (!target.classList.contains("animated-out")) {
                        // Animate out only if not already animated out
                        gsap.fromTo(
                            wordElements,
                            { y: 0 },
                            {
                                y: 65,
                                duration: 0.5,
                                stagger: 0.05,
                                delay: 0,
                            },
                        );
                        target.classList.add("animated-out");
                        target.classList.remove("animated-in");
                    }
                }
            });
        };
        // function checkHeadingVisibility() {

        // }

        function additionalClassParent() {
            console.log("animate-heading test");
            document.querySelectorAll(".animate-heading .line-parent").forEach((el) => {
                el.classList.add("relative", "overflow-hidden");
            });
        }

        // Throttle for performance
        let oCTicking = false;
        window.addEventListener("scroll", function () {
            if (!oCTicking) {
                window.requestAnimationFrame(() => {
                    checkHeadingVisibility();
                    oCTicking = false;
                });
                oCTicking = true;
            }
        });
        window.addEventListener("load", function () {
            checkHeadingVisibility();
            additionalClassParent();
        });
        window.addEventListener("resize", function () {
            additionalClassParent();
        });
    }
}

export default AnimateHeading;
